// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* "Confirm how you found this worker" (GRAVY-10443; Figma 40569:193560). The
   dialog shell, fields and buttons are the shared \`paysurge-\` ones; these are
   only the worker card and the field stack. */

.hiresource-worker {
  display: flex;
  align-items: center;
  gap: 16px;
}
.hiresource-avatar {
  flex: 0 0 auto;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}
.hiresource-avatar.is-initials {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eaeaea;
  font-size: 20px;
  font-weight: 700;
  color: #5b5b5b;
}
.hiresource-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}
.hiresource-name {
  font-size: 20px;
  font-weight: 800;
  line-height: 1.4;
  color: #1c1c1c;
}
.hiresource-stats {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.hiresource-stat {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #6f6f6f;
}
.hiresource-stat + .hiresource-stat {
  padding-left: 8px;
  border-left: 1px solid #dadada;
}
.hiresource-stat b {
  font-weight: 700;
  color: #1c1c1c;
}
.hiresource-star {
  width: 18px;
  height: 18px;
  color: #eca300;
}
.hiresource-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Agency/HireSourcing/hireSourcing.css"],"names":[],"mappings":"AAAA;;8CAE8C;;AAE9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX","sourcesContent":["/* \"Confirm how you found this worker\" (GRAVY-10443; Figma 40569:193560). The\n   dialog shell, fields and buttons are the shared `paysurge-` ones; these are\n   only the worker card and the field stack. */\n\n.hiresource-worker {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.hiresource-avatar {\n  flex: 0 0 auto;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n.hiresource-avatar.is-initials {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #eaeaea;\n  font-size: 20px;\n  font-weight: 700;\n  color: #5b5b5b;\n}\n.hiresource-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n.hiresource-name {\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 1.4;\n  color: #1c1c1c;\n}\n.hiresource-stats {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n.hiresource-stat {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: #6f6f6f;\n}\n.hiresource-stat + .hiresource-stat {\n  padding-left: 8px;\n  border-left: 1px solid #dadada;\n}\n.hiresource-stat b {\n  font-weight: 700;\n  color: #1c1c1c;\n}\n.hiresource-star {\n  width: 18px;\n  height: 18px;\n  color: #eca300;\n}\n.hiresource-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
